import { ErrorReporter } from "../lib/createErrorHandler";

export const localErrorHandler = console.error as ErrorReporter;
